export const blockIconsSocialMilitaryTech = (
	<span className='material-symbols-outlined'>military_tech</span>
);
